import { createSvgIcon } from '@mui/material'

export const ManageRollover = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 28 28'>
    <defs>
      <clipPath id='clip-path'>
        <path id='path1752' d='M0-682.665H28v28H0Z' transform='translate(0 682.665)' fill='#ffd600' />
      </clipPath>
    </defs>
    <g id='g1750' clip-path='url(#clip-path)'>
      <g id='g1756' transform='translate(0.82 18.43)'>
        <path
          id='path1758'
          d='M-153.437,0h-2.187A4.375,4.375,0,0,0-160,4.375V5.469h10.938V4.375A4.375,4.375,0,0,0-153.437,0Z'
          transform='translate(160)'
          fill='rgba(0,0,0,0)'
          stroke='#fff'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-miterlimit='10'
          stroke-width='1.25'
        />
      </g>
      <g id='g1760' transform='translate(3.008 11.867)'>
        <path
          id='path1762'
          d='M-153.437-76.719a3.281,3.281,0,0,1-3.281,3.281A3.281,3.281,0,0,1-160-76.719,3.281,3.281,0,0,1-156.718-80,3.281,3.281,0,0,1-153.437-76.719Z'
          transform='translate(160 80)'
          fill='rgba(0,0,0,0)'
          stroke='#fff'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-miterlimit='10'
          stroke-width='1.25'
        />
      </g>
      <path
        id='path1764'
        d='M509.228-656.1h-6.562v-6.562h6.563Z'
        transform='translate(-482.048 663.485)'
        fill='rgba(0,0,0,0)'
        stroke='#fff'
        stroke-linecap='round'
        stroke-linejoin='round'
        stroke-miterlimit='10'
        stroke-width='1.25'
      />
      <g id='g1766' transform='translate(23.352 2.461)'>
        <path
          id='path1768'
          d='M-89.5,0l-2.552,2.552-1.276-1.276'
          transform='translate(93.333)'
          fill='rgba(0,0,0,0)'
          stroke='#fff'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-miterlimit='10'
          stroke-width='1.25'
        />
      </g>
      <path
        id='path1770'
        d='M509.228-414.77h-6.562v-6.562h6.563Z'
        transform='translate(-482.048 432.051)'
        fill='rgba(0,0,0,0)'
        stroke='#fff'
        stroke-linecap='round'
        stroke-linejoin='round'
        stroke-miterlimit='10'
        stroke-width='1.25'
      />
      <g id='g1772' transform='translate(23.352 12.359)'>
        <path
          id='path1774'
          d='M-89.5,0l-2.552,2.552-1.276-1.276'
          transform='translate(93.333)'
          fill='rgba(0,0,0,0)'
          stroke='#fff'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-miterlimit='10'
          stroke-width='1.25'
        />
      </g>
      <path
        id='path1776'
        d='M509.228-173.437h-6.562V-180h6.563Z'
        transform='translate(-482.048 200.617)'
        fill='rgba(0,0,0,0)'
        stroke='#fff'
        stroke-linecap='round'
        stroke-linejoin='round'
        stroke-miterlimit='10'
        stroke-width='1.25'
      />
      <g id='g1778' transform='translate(23.352 22.258)'>
        <path
          id='path1780'
          d='M-89.5,0l-2.552,2.552-1.276-1.276'
          transform='translate(93.333)'
          fill='rgba(0,0,0,0)'
          stroke='#fff'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-miterlimit='10'
          stroke-width='1.25'
        />
      </g>
      <g id='g1782' transform='translate(15.586 14)'>
        <path
          id='path1784'
          d='M0,0H5.031'
          fill='rgba(0,0,0,0)'
          stroke='#fff'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-miterlimit='10'
          stroke-width='1.25'
        />
      </g>
      <g id='g1786' transform='translate(15.586 4.102)'>
        <path
          id='path1788'
          d='M-117.635-462.869h-5.031v-19.8h5.031'
          transform='translate(122.666 482.665)'
          fill='rgba(0,0,0,0)'
          stroke='#fff'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-miterlimit='10'
          stroke-width='1.25'
        />
      </g>
      <g id='g1790' transform='translate(11.758 23.898)'>
        <path
          id='path1792'
          d='M-89.5,0h-3.828'
          transform='translate(93.333)'
          fill='rgba(0,0,0,0)'
          stroke='#fff'
          stroke-linecap='round'
          stroke-linejoin='round'
          stroke-miterlimit='10'
          stroke-width='1.25'
        />
      </g>
    </g>
  </svg>,
  'ManageRollover'
)
